import React, { Component } from "react";
import Banner from "../../component/projectDetail/Banner";
import axios from "axios";
import * as _ from "lodash";
import { authService } from "../../../auth";
import { Link, Redirect } from "react-router-dom";
import StudioListData from "../../component/Studio/StudioListData";
import LeftPanel from "../../../LeftPanel";
import Header from "../../../Header";
import { redirecToStudiopage, studioPageErrorMessagePopUp } from "../../component/Studio/StudioContentCommonFunction";
import StudioTermsAndConditionPopUp from "../../component/Studio/StudioTermsAndConditionPopUp";
import HideInfoPage from "../../../static/HideInfoPage";
import PrivateProjectHidePage from "../../../static/PrivateProjectHidePage";
import {withRouter} from "react-router-dom";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";
import SendMessageModal from "../../../commons/SendMessageModal";
import CleverTapUtils from "../../../commons/CleverTapUtils";
class ProjectStudioContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projectId: undefined,
            userData: authService.getUserDetailsFromLocalStorage(),
            projectDetail: {},
            studioDataConfig: {},
            allowAccess: false,
            showTermsAndCond: true,
            studioDataListFlag: false,
            responseMessage: "",
            notFoundstatusCode: "",
            openSendMessageModal: null,
            userId: this.props?.location?.state?.userId ? this.props?.location?.state?.userId : authService.getUserDetailsFromLocalStorage().userId
        }
    }

    getUserStudioTermsAndCondition = () => {
        axios({
            method: "GET",
            url: `${process.env.REACT_APP_userServiceURL}/StudioTermsAndCondition/getUser?userId=${this.state.userId}`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
        .then((response) => {
            let res = response.data;
            if (res.status === "200 OK") {
                this.setState({ showTermsAndCond: res.body},() => {
                    if(res.body) {
                        this.setState({
                            studioDataListFlag: true
                        })
                    } else {
                        window.$("#studioUserTermsCond").modal("show");
                    }
                });
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };

    acceptStudioTermsAndCond = () => {
        this.setState({
            studioDataListFlag: true,
            showTermsAndCond: false
        })
        window.$("#studioUserTermsCond").modal("hide");
    }

    getProjectDetail = (slug) => {
        axios({
            method: "get",
            url: `${process.env.REACT_APP_userServiceURL}/participants/find-project-description-details-by-userId-and-slug/${this.state.userId}/${slug}`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
        .then((response) => {
            let res = response.data;
            if (res.status === "200 OK") {
                this.setState({ projectDetail: res.body, responseMessage: res.message},() => {
                    if(this.state.projectDetail && !this.state.projectDetail.privateProjectRestriction) {
                        this.getStudioContentConfig(this.state.projectDetail.projectId);
                    }   
                });
            }
        })
        .catch((err) => {
            console.log(err);
            this.setState({
                notFoundstatusCode: err.response.status,
                responseMessage: "Success!"
            })
        });
    };

    getStudioContentConfig = (projectId) => {
        let userId = this.state.userId;
        if(this.state.projectDetail && this.state.projectDetail.partyType && (this.state.projectDetail.partyType === 'BUSINESS_PAGES' || this.state.projectDetail.partyType === 'COMPANIES') &&
            this.state.projectDetail.participationDetails && this.state.projectDetail.participationDetails.participatingUserId){
            userId = this.state.projectDetail.participationDetails.participatingUserId;
        }
        if(this.state.projectDetail && this.state.projectDetail.partyType === "CIRCLE"){
            userId = this.state.projectDetail?.superAdminId;
        }
        axios({
            method: "get",
            url: `${process.env.REACT_APP_userServiceURL}/studio/config?userId=${userId}&entityId=${projectId}`,
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
        })
        .then((response) => {
            let res = response.data;
            if (res.status === "200 OK") {
                this.setState({ studioDataConfig: res.body});
            }
        })
        .catch((err) => {
            console.log(err);
        });
    };

    redirecToStudiopage = (studioDataConfig, projectDetail) => {
        CleverTapUtils.eventClick({}, "Post in Studio");
        if(studioDataConfig && studioDataConfig.postCreationAllowed) {
            this.props.history.push({
                pathname: `/project/post-studio/${projectDetail.projectId}`,
                state: {
                    userId: projectDetail.partyType === "CIRCLE" ? /* this.state.userData.userId */projectDetail.superAdminId : projectDetail.userId
                }
            })
        } else {
            studioDataConfig.superAdminName = this.state.projectDetail?.superAdminName;
            studioDataConfig.superAdminId = this.state.projectDetail?.superAdminId;
            studioPageErrorMessagePopUp(studioDataConfig, this.sendMessageButtonClick);
        }
    }

    sendMessageButtonClick = (type) => {
        if(!type) {
            this.setState({openSendMessageModal: this.state.projectDetail?.superAdminId});
        } else {
            this.props.history.push({
                pathname: "/wenaturalists-pro",
                state: { userId:  this.state.studioDataConfig?.userId}
            })
        }
    }

    triggerMessageModalClose = () => {
        this.setState({
            openSendMessageModal: null
        })
    }

    componentDidMount() {
        this.getUserStudioTermsAndCondition();
        this.getProjectDetail(this.props.match.params.slug);
    }

    render() {
        return (
            <div className="projectpage">
                <div className="wrapper">
                    <Header />
                    {this.state.responseMessage === "Success!" &&
                        (this.state.notFoundstatusCode === 404 || (this.state.projectDetail && (this.state.projectDetail.hidden || this.state.projectDetail.privateProjectRestriction)) ?
                            <main className="dgcontainer hm3col">
                                <div className="container">
                                    {this.state.notFoundstatusCode === 404 && this.state.projectDetail.userId != this.state.userId ? <HideInfoPage deletePost={true} projectDelete={true} /> :
                                    (this.state.projectDetail.hidden && (this.state.projectDetail.userId != this.state.userId) && (this.state.projectDetail.creatorUserId != this.state.userId)) ? <PrivateProjectHidePage myStudioPage={true} /> : 
                                    (this.state.projectDetail && this.state.projectDetail.privateProjectRestriction) ? <PrivateProjectHidePage /> : null}
                                </div>
                            </main> :
                            <main className="dgcontainer hm3col">
                                <div className="container">
                                    <div className="row">
                                        <LeftPanel/>
                                        <div className="col-md-9">                                            
                                            <div className="projectinn nothidden projdetailscont pdPaidProjPage">
                                                <Banner projectDetail={this.state.projectDetail} isStudioPage={true} userId={this.state.userId} />
                                                {this.state.userId && <OrganizationAdmin userId={this.state.userId} />}
                                                <div className="projdetlswrap">
                                                    <div className="paidProjWrap">
                                                        {this.state.projectDetail && this.state.projectDetail?.postInStudioPermission && <div className="ppPostBtn">
                                                            <span><a href="javascript:void(0)" onClick={(e) => this.redirecToStudiopage(this.state.studioDataConfig, this.state.projectDetail)} className="btn">Post in Studio</a></span>
                                                        </div>}
                                                        {!_.isEmpty(this.state.projectDetail) && this.state.studioDataListFlag && <StudioListData projectId={this.state.projectDetail.projectId} projectUserId={this.state.projectDetail.userId} projectCreatorUserId={this.state.projectDetail.creatorUserId} studioDataConfig={this.state.studioDataConfig} studioPageType={"PROJECT"} userId={this.state.userId} postInStudioPermission={this.state.projectDetail?.postInStudioPermission} projectDetail={this.state.projectDetail} sendMessageButtonClick={this.sendMessageButtonClick} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        )
                    }
                </div>

                {!this.state.showTermsAndCond && 
                    <StudioTermsAndConditionPopUp key={this.state.userId} acceptStudioTermsAndCond={this.acceptStudioTermsAndCond} userId={this.state.userId} history={this.props.history} />
                }

                {this.state.openSendMessageModal &&
                    <SendMessageModal profileId={this.state.projectDetail.superAdminId}
                                        userName={this.state.projectDetail?.superAdminName} 
                                        triggerMessageModalClose={this.triggerMessageModalClose}/>
                }
            </div>
        );
    }
}

export default withRouter(ProjectStudioContainer);
